<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column">
    <div class="row f-row justify-content-center h-100">
      <div class="col col-12 text-center" style="height:100%; width:100%">
        <!-- Chart 1 -->
        <div class="container-chart-COT" style="height:61%;">
          <!-- Row: title -->
          <div class="row f-row markets-chart-title d-flex align-items-center">
            <div class="col col-6" style="font-size: 0.9rem">
              Commitments of Traders for
              <span style="color: var(--textactive)">
                {{ assetString }}
              </span>
              &nbsp;|&nbsp; Last update:
              <span style="color: var(--textactive)">
                {{ lastUpdate | dateFormat }}
              </span>
            </div>
            <slot name="spot"></slot>
          </div>
          <!-- Row: controls and labels -->
          <div
            class="row f-row justify-content-center"
            style="vertical-align: middle!important; padding: 0 60px 0 12px;"
          >
            <div class="col col-12 txt-label-primary-2">
              <div
                class="row f-row justify-content-center mt-2 d-flex"
                style="vertical-align: middle!important; align-items: end;"
              >
                <div
                  class="col col-auto txt-label-primary-2 text-center"
                  style="align-items: end!important; padding-right: 6px!important;"
                >
                  Asset:
                </div>
                <div
                  class="col col-1 text-left"
                  style="z-index: 1001!important; align-self: flex-end;"
                >
                  <Dropdown
                    v-model="selectedAssetType"
                    :options="assetTypes"
                    @change="onSelectedAssetType"
                    optionLabel="asset"
                    optionValue="id"
                    placeholder="Select Asset"
                    scrollHeight="400px"
                  >
                    <template #value="slotProps">
                      {{ assetTypes[slotProps.value].asset }}
                    </template>
                    <template #option="slotProps">
                      <div class="country-item">
                        <div>{{ slotProps.option.asset }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>

                <div
                  class="col col-auto txt-label-primary-2 text-center"
                  style="align-items: end!important; padding: 0 6px 0 12px!important;"
                >
                  Select:
                </div>
                <div
                  class="col col-1 text-left"
                  style="z-index: 1001!important; align-self: flex-end;"
                  v-show="selectedAssetType === 0"
                >
                  <Dropdown
                    v-model="selectedAsset0"
                    :options="
                      currencySpecsFiltered.map((d, i) => {
                        return { asset: d.currency_name, id: i };
                      })
                    "
                    @change="onUserAssetSelection"
                    optionLabel="asset"
                    optionValue="id"
                    placeholder="Select Currency"
                    scrollHeight="400px"
                    :filter="true"
                  >
                    <template #value="slotProps">
                      {{
                        currencySpecsFiltered[
                          slotProps.value
                        ].currency_name.toUpperCase()
                      }}
                    </template>
                    <template #option="slotProps">
                      <div class="country-item">
                        <div>{{ slotProps.option.asset }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
                <div
                  class="col col-1 ml-1 mr-1 text-left"
                  style="z-index: 1001!important; align-self: flex-end;"
                  v-show="selectedAssetType === 1"
                >
                  <Dropdown
                    v-model="selectedAsset1"
                    :options="
                      commoditySpecsFiltered.map((d, i) => {
                        return { asset: d.fk_idproduct.toUpperCase(), id: i };
                      })
                    "
                    @change="onUserAssetSelection"
                    optionLabel="asset"
                    optionValue="id"
                    placeholder="Select Commodity"
                    scrollHeight="400px"
                    :filter="true"
                  >
                    <template #value="slotProps">
                      {{
                        commoditySpecsFiltered[
                          slotProps.value
                        ].fk_idproduct.toUpperCase()
                      }}
                    </template>
                    <template #option="slotProps">
                      <div class="country-item">
                        <div>{{ slotProps.option.asset }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
                <div
                  class="col col-1 ml-1 mr-1 text-left"
                  style="z-index: 1001!important;"
                  v-show="selectedAssetType === 2"
                >
                  <span v-if="showLoadingInd" class="text-right">
                    <QSLoading
                      :isLoading="showLoadingInd"
                      :size="35"
                      :colorTheme="colorTheme"
                    />
                  </span>
                  <Dropdown
                    v-model="selectedAsset2"
                    :options="
                      indexSpecsLocal.map((d, i) => {
                        return { asset: d.short_name.toUpperCase(), id: i };
                      })
                    "
                    @change="onUserAssetSelection"
                    optionLabel="asset"
                    optionValue="id"
                    placeholder="Select Index"
                    scrollHeight="400px"
                    :filter="true"
                  >
                    <template #value="slotProps">
                      {{ indexSpecsLocal[slotProps.value].short_name }}
                    </template>
                    <template #option="slotProps">
                      <div class="country-item">
                        <div>{{ slotProps.option.asset }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>

                <div
                  class="col col-auto txt-label-primary-2 text-center"
                  style="align-items: end!important; padding: 0 6px 0 12px!important;"
                >
                  Range:
                </div>
                <div class="h-100" style="width: 27px;">
                  <HoverMultiSelection
                    :btnWidth="'2.5rem'"
                    :options="[
                      { label: '1Y', value: '1Y' },
                      { label: '2Y', value: '2Y' },
                      { label: '3Y', value: '3Y' },
                      { label: '5Y', value: '5Y' },
                      { label: '10Y', value: '10Y' },
                      { label: '20Y', value: '20Y' },
                    ]"
                    :selected="pickedDateInterval"
                    @eventOnChangeOption="(opt) => onChangeInterval(opt.value)"
                  />
                </div>

                <!-- Table -->
                <div
                  class="col col-cx txt-label-primary-2 text-center COT-table-container"
                >
                  <div v-if="showLoading || showLoadingDataPrep">
                    <QSLoading
                      :isLoading="showLoading || showLoadingDataPrep"
                      :size="20"
                      :colorTheme="colorTheme"
                    />
                  </div>
                  <table
                    class="commitment_traders_table"
                    v-for="(net, i) in formatVars['tableFormat']"
                    :key="i * 2"
                  >
                    <thead>
                      <tr>
                        <th
                          v-for="(interval, i) in formatVars['intervalTable']"
                          :key="i"
                        >
                          {{ interval }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td :style="{ color: 'var(--textinactive)' }">
                          {{ net["label"] }}
                        </td>
                        <td
                          :style="{
                            'background-color': net['back'],
                            'border-bottom': '1px solid ' + net['bdr'],
                          }"
                        >
                          {{ net["Today"] | priceFormat }}
                        </td>
                        <td
                          :style="{
                            'background-color': net['back'],
                            'border-bottom': '1px solid ' + net['bdr'],
                          }"
                        >
                          {{ net["1W"] | priceFormat }}
                        </td>
                        <td
                          :style="{
                            'background-color': net['back'],
                            'border-bottom': '1px solid ' + net['bdr'],
                          }"
                        >
                          {{ net["4W"] | priceFormat }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- Row: Chart -->
          <div class="row f-row h-100" style="position: relative;">
            <!-- Row: legend -->
            <div class="row f-row container-legends-COT">
              <div class="col col-auto text-left" style="z-index: 1;">
                <table
                  class="table table-sm table-responsive table-borderless table-market-legend"
                  style="width: 100%; background: rgba(0,0,0,0)"
                >
                  <tbody>
                    <tr>
                      <td class="text-left">
                        <i class="fa fa-minus mr-1" style="color:var(--expo)">
                        </i>
                        Close<span
                          >:
                          <div
                            id="closeCOT"
                            class="candle-hover-info text-center inline-ul"
                          >
                            -
                          </div>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="col col-12 text-center progress-div"
              style="top: 50%;"
              v-if="loading.historical"
            >
              <QSLoading
                :isLoading="loading.historical"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              class="col col-12 text-center"
              v-else-if="allData.historical.length === 0"
              style="position: absolute; left: 0; top: 50%; z-index: 1001;"
            >
              No Data Available
            </div>
            <div class="col col-12" style="height:100%; width:100%">
              <div
                class="h-100 d-flex flex-column"
                id="commitmentTraders-div"
                style="width: 100%;"
              >
                <svg id="svg-commitmentTraders"></svg>
              </div>
            </div>
          </div>
        </div>
        <!-- Chart 2 -->
        <div
          class="container-chart-COT"
          style="height:19%; position: relative;"
        >
          <!-- Row: legend -->
          <div class="row f-row container-legends-COT">
            <div class="col col-auto text-left" style="z-index: 1000;">
              <table
                class="table table-sm table-responsive table-borderless table-market-legend"
                style="background: rgba(0,0,0,0)"
              >
                <tbody>
                  <tr>
                    <td
                      class="text-left"
                      v-for="(net, i) in formatVars['tableFormat']"
                      :key="i"
                    >
                      <button
                        class="btn detailView"
                        v-on:click="onShow(i)"
                        style="padding-left: 0!important;"
                      >
                        <div
                          v-if="userSelections[net['showFieldName']]"
                          class="triangle-topleft-net"
                          :style="{
                            'border-top': '0.71rem solid ' + net['bdr'],
                            'border-right': '0.71rem solid ' + net['dn'],
                          }"
                        ></div>
                        <div v-else class="triangle-topleft-2"></div>
                      </button>
                      {{ net["label"] }}
                      <span
                        >:
                        <div
                          class="candle-hover-info text-center inline-ul"
                          :id="net['elementName']"
                        >
                          -
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Row: Chart -->
          <div class="row f-row h-100">
            <div
              class="col col-12 text-center progress-div"
              style="top: 59.5%;"
              v-if="loading.historical"
            >
              <QSLoading
                :isLoading="loading.historical"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              class="col col-12 text-center"
              v-else-if="allData.historical.length === 0"
              style="position: absolute; left: 0; top: 59.5%; z-index: 1000;"
            >
              No Data Available
            </div>
            <div class="col col-12" style="height:100%; width:100%">
              <div
                class="h-100 d-flex flex-column"
                id="net-div"
                style="width: 100%; "
              >
                <svg id="svg-net"></svg>
              </div>
            </div>
          </div>
        </div>
        <!-- Chart 3 -->
        <div class="container-chart-COT" style="height:19%;">
          <!-- Row: legend -->
          <div class="row f-row container-legends-COT">
            <div class="col col-auto text-left" style="z-index: 1000;">
              <table
                class="table table-sm table-responsive table-borderless table-market-legend"
                style="background: rgba(0,0,0,0)"
              >
                <tbody>
                  <tr>
                    <td class="text-left">
                      <div class="triangle-topleft-1"></div>
                      Open interest<span
                        >:
                        <div
                          id="barOIHistogram"
                          class="candle-hover-info text-center inline-ul"
                        >
                          -
                        </div>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Row: Chart -->
          <div class="row f-row h-100">
            <div
              class="col col-12 text-center progress-div"
              style="top: 45%;"
              v-if="loading.historical"
            >
              <QSLoading
                :isLoading="loading.historical"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              class="col col-12 text-center"
              v-else-if="allData.historical.length === 0"
              style="position: absolute; left: 0; top: 50%; z-index: 1000;"
            >
              No Data Available
            </div>
            <div class="col col-12" style="height:100%; width:100%">
              <div
                class="h-100 d-flex flex-column"
                id="open-interest-div"
                style="width: 100%; "
              >
                <svg id="svg-open-interest"></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  assets,
  colorDarkExpo,
  colorExpo,
  colorExpoAlpha,
  colorExpoAlpha2,
  colorExpoAlpha4,
  colorFwdAlpha2,
  colorFwdAlpha3,
  colorFwdF,
  colorHedge,
  colorHedgeAlpha,
  colorHedgeAlpha2,
  commoditySpecsConst,
  currencyFormat,
  currencySpecsConst,
  dateFormat,
  tDaysW,
  textactive,
  textactive2,
  textactiveAlpha,
} from "@/_core/_helpers/_parametric_tools";
import { additionalYSpace, lengthByDate } from "@/_core/_helpers/_helpers";
import { Chart } from "@/_core/refactor/Chart";
import { CommitmentTradersHover } from "@/_core/charts/CommitmentTraders";
import { D3HoverZoom } from "@/_core/refactor/effects/D3Hover";
import { DotHover } from "@/_core/refactor/effects/DotHover";
import { format, select, timeFormat, zoomIdentity } from "d3";
import {
  getCommitmentTraders,
  getCommitmentTradersFiltersData,
} from "@/_core/data/api_calls/getCommitmentTraders";
import { inRange } from "@/_core/charts/TechnicalAnalysis";
import { LineHover } from "@/_core/refactor/effects/LineHover";
import { NetHover } from "@/_core/charts/CommitmentTradersNet";
import Dropdown from "primevue/dropdown";
import HoverMultiSelection from "@/components/buttons/HoverMultiSelection.vue";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "CommitmentOfTraders",
  components: {
    Dropdown,
    HoverMultiSelection,
    QSLoading,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    commodityDefs: {
      required: false,
      type: Object,
      default() {
        return {};
      },
    },
    commoditySpecs: { required: true, default: () => [] },
    currencyDefs: {
      required: false,
      type: Object,
      default() {
        return {};
      },
    },
    currencySpecs: { required: true, default: () => [] },
    indexSpecs: { required: true, default: () => [] },
    isCurrency: { required: true, type: Boolean, default: true },
    processData: { required: true },
  },
  data() {
    return {
      allData: {
        cotPKByCurrency: {},
        cotPKByCommodity: {},
        cotPKByIndex: {},
        filterData: [],
        histAsset: [],
        historical: [],
        historicalSliced: [],
        indexSpecsLocal: [],
        keys: [],
        minMaxYAxis: [-Infinity, Infinity],
      },
      loading: {
        cotFilter: false,
        historical: true,
        indexes: false,
      },
      formatVars: {
        colorComBack: colorHedgeAlpha,
        colorComDn: colorHedgeAlpha2,
        colorComUp: colorHedge,
        colorHighlight: textactive2,
        colorHighlightAlpha: textactiveAlpha,
        colorLine: colorExpo,
        colorLineArea: colorExpoAlpha,
        colorNonComBack: colorExpoAlpha4,
        colorNonComDn: colorExpoAlpha2,
        colorNonComUp: colorExpo,
        colorNonRepBack: colorFwdAlpha2,
        colorNonRepDn: colorFwdAlpha3,
        colorNonRepUp: colorFwdF,
        colorOpIntDn: colorExpoAlpha2,
        colorOpIntUp: colorExpo,
        intervalTable: ["", "Today", "1W", "4W"],
        logo: require("@/assets/images/symbol_blue.svg"),
        tableFormat: [
          {
            k: "current",
            back: "rgba(0,0,0,0)",
            bdr: "rgba(0,0,0,0)",
            elementName: "...",
            label: "...",
            Today: "",
            "1W": "",
            "4W": "",
          },
        ],
      },
      userSelections: {
        showComm: true,
        showNonComm: true,
        showNonRep: true,
      },
      additionalDates: [],
      assetTypes: assets,
      barWidth: 0.6,
      chartBodyCOT: [],
      commoditySpecsFiltered: commoditySpecsConst,
      comparedAsset: "N.A",
      comparedAssetLong: "N.A",
      currencyFormat: currencyFormat,
      currencyNumber: 1,
      currencySpecsFiltered: currencySpecsConst,
      dateFormat: dateFormat,
      externalZoom: false,
      fieldUp: "close",
      initCommodityDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      keepDateInterval: true,
      chartBodyNet: [],
      chartBodyOI: [],
      pickedDateInterval: "5Y",
      selectedAsset0: 0,
      selectedAsset1: 0,
      selectedAsset2: 0,
      selectedAssetType: 0,
      selectedWeeks: 261,
      showLoading: false,
      showLoadingDataPrep: false,
      showLoadingInd: false,
      svgNode: null,
      svgNodeNet: null,
      tDaysW: tDaysW,
      transform: null,
      transformY: null,
      xt: null,
      zoomSpread: null,
      zoomCOT: null,
      zoomCOTY: null,
      candleWidth: 0,
      candleHeight: 0,
    };
  },
  computed: {
    lastUpdate() {
      if (this.allData.historical.length === 0) {
        return "...";
      } else {
        return this.allData.historical[this.allData.historical.length - 1].date;
      }
    },
    loadingDropdowns() {
      return this.loading["cotFilter"] || this.loading["indexes"];
    },
    loadingHistorical() {
      return this.loading["historical"];
    },
    assetString() {
      let sel, str;
      if (this.selectedAssetType === 0) {
        sel = this.currencySpecsFiltered[this.selectedAsset0];
        str = sel.currency_name;
      } else if (this.selectedAssetType === 1) {
        sel = this.commoditySpecsFiltered[this.selectedAsset1];
        str =
          sel.commodity_name +
          " - CONTRACT # " +
          sel.selected_contract +
          " (" +
          (sel.is_cents ? "USc" : sel.fk_idcurrency) +
          "/" +
          sel.fk_idunit +
          ")";
      } else if (this.selectedAssetType === 2) {
        sel = this.indexSpecsLocal[this.selectedAsset2];
        str = sel.long_name;
      }
      return str;
    },
  },
  created() {
    Object.assign(this, { indexSpecsLocal: this.indexSpecs });
    Object.assign(this.loading, { cotFilter: true });
    getCommitmentTradersFiltersData(this);
    this.createTableFormat();

    this.selectedAssetType = this.isCurrency ? 0 : 1;
    let dat = new Date();
    let day = dat.getDate();
    let days = day === 0 ? 1 : day;
    dat.setDate(days);
    this.additionalDates = this.processData.createNWeeks(dat, 8);
    // ===== create initial charts instances =====
    this.D3ChartOI = new Chart("open-interest");
    this.D3ChartCOT = new Chart("commitmentTraders");
    this.D3ChartNET = new Chart("net");
  },
  mounted() {
    let _this = this;
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  watch: {
    indexSpecs() {
      Object.assign(this, { indexSpecsLocal: this.indexSpecs });
      this.assetExists();
      this.getAllData();
    },
    currencyDefs() {
      this.selectedAssetType = 0;
      this.assetExists();
      this.getAllData();
    },
    commodityDefs() {
      this.selectedAssetType = 1;
      this.assetExists();
      this.getAllData();
    },
    colorTheme() {
      this.callWidth();
    },
    loadingHistorical(val) {
      if (val === false) {
        this.showLoading = val;
        this.dataAndCharts();
        this.showLoadingDataPrep = false;
      }
    },
    loadingDropdowns(val) {
      if (val === false) {
        let _this = this;
        let currF = this.allData["filterData"].map((d) => +d.fk_currency);
        this.cotPKByCurrency = {};
        let i;
        for (i = 0; i < currF.length; i++) {
          if (+_this.allData["filterData"][i]["fk_currency"] !== 0) {
            _this.cotPKByCurrency[
              _this.allData["filterData"][i]["fk_currency"]
            ] = _this.allData["filterData"][i]["pk_cot_codes"];
          }
        }
        let currSpec = JSON.parse(JSON.stringify(this.currencySpecs));
        let currSpecF = currSpec.filter((d) =>
          currF.includes(d.pk_i_idcurrency),
        );
        Object.assign(this, { currencySpecsFiltered: currSpecF });

        let commF = this.allData["filterData"].map((d) => +d.fk_commodities);
        this.cotPKByCommodity = {};
        for (i = 0; i < currF.length; i++) {
          if (+_this.allData["filterData"][i]["fk_commodities"] !== 0) {
            _this.cotPKByCommodity[
              _this.allData["filterData"][i]["fk_commodities"]
            ] = _this.allData["filterData"][i]["pk_cot_codes"];
          }
        }
        let commSpec = JSON.parse(JSON.stringify(this.commoditySpecs));
        let commSpecF = commSpec.filter((d) =>
          commF.includes(d.pk_idcommodity),
        );
        Object.assign(this, { commoditySpecsFiltered: commSpecF });

        this.indexSpecsLocal = this.indexSpecs.filter(
          this.processData.onlyUnique,
        );
        let idxF = this.allData["filterData"].map((d) => +d.fk_index);
        this.cotPKByIndex = {};
        for (i = 0; i < currF.length; i++) {
          if (+_this.allData["filterData"][i]["fk_index"] !== 0) {
            _this.cotPKByIndex[_this.allData["filterData"][i]["fk_index"]] =
              _this.allData["filterData"][i]["pk_cot_codes"];
          }
        }
        let idxSpecF = this.indexSpecsLocal.filter((d) =>
          idxF.includes(d.pk_i_idindexes),
        );
        Object.assign(_this, { indexSpecsLocal: idxSpecF });
        this.assetExists();
        this.getAllData();
      }
    },
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : val === "..."
        ? val
        : timeFormat("%b %d, %y")(val);
    },
  },
  methods: {
    onShow(val) {
      let bool;
      if (val === 0) {
        bool = this.userSelections["showNonComm"];
        Object.assign(this.userSelections, { showNonComm: !bool });
      } else if (val === 1) {
        bool = this.userSelections["showComm"];
        Object.assign(this.userSelections, { showComm: !bool });
      } else if (val === 2) {
        bool = this.userSelections["showNonRep"];
        Object.assign(this.userSelections, { showNonRep: !bool });
      }
      this.callWidth();
    },
    assetExists() {
      let _this = this;
      let idx, currF, commF;
      if (this.isCurrency) {
        currF = this.currencySpecsFiltered.map((d) => +d.pk_i_idcurrency);
        idx = currF.indexOf(_this.currencyDefs.pk_i_idcurrency);
        if (idx > -1) {
          this.selectedAsset0 = idx;
        } else {
          this.selectedAsset0 = 0;
        }
      } else {
        commF = this.commoditySpecsFiltered.map((d) => +d.pk_idcommodity);
        idx = commF.indexOf(_this.commodityDefs.pk_idcommodity);
        if (idx > -1) {
          this.selectedAsset1 = idx;
        } else {
          this.selectedAsset1 = 0;
        }
      }
    },
    deleteCharts() {
      select("#commitmentTraders-div")
        .selectAll(".tooltip")
        .remove();
      select("#commitmentTraders-div")
        .select("svg > *")
        .remove();
      select("#net-div")
        .selectAll(".tooltip")
        .remove();
      select("#net-div")
        .select("svg > *")
        .remove();
      select("#open-interest-div")
        .selectAll(".tooltip")
        .remove();
      select("#open-interest-div")
        .select("svg > *")
        .remove();
    },
    dataAndCharts() {
      this.sliceMethod();
      this.createCharts();
      this.createHoverFX();
    },
    sliceMethod() {
      if (this.allData.historical.length === 0) {
        return;
      }
      this.keepDateInterval = true;
      let selectedWeeks = this.tDaysW[this.pickedDateInterval];
      Object.assign(this.allData, {
        historicalSliced: this.processData.toSlice(
          this.allData["historical"],
          selectedWeeks,
        ),
      });
      let col;
      let _this = this;
      const fillColors = (
        data,
        dataFilter,
        minorColor,
        majorColor,
        fillColor,
        i,
      ) => {
        col =
          data[dataFilter] >= _this.allData.historical[i - 1][dataFilter]
            ? majorColor(_this.colorTheme)
            : minorColor(_this.colorTheme);
        data[fillColor] = col;
      };
      this.allData.historical.forEach(function(d, i) {
        d.zero = 0;
        d.pHighlight = d.highlight ? d.close : null;
        d.cotHighlight = d.highlight ? d.non_commercial_net : null;
        d.cotHighlightColor = _this.formatVars["colorHighlightAlpha"](
          _this.colorTheme,
        );
        if (i === 0) {
          d.colorSel = "rgba(0, 0, 0, 0)";
          d.fillColorSel = _this.formatVars["colorComUp"](_this.colorTheme);
          d.fillColorSelNR = _this.formatVars["colorNonRepUp"](
            _this.colorTheme,
          );
          d.fillColorSelNC = _this.formatVars["colorNonComUp"](
            _this.colorTheme,
          );
          d.fillColorSelOI = _this.formatVars["colorOpIntUp"](_this.colorTheme);
        } else {
          d.colorSel = "rgba(0, 0, 0, 0)";
          fillColors(
            d,
            "commercial_net",
            _this.formatVars["colorComDn"],
            _this.formatVars["colorComUp"],
            "fillColorSel",
            i,
          );
          fillColors(
            d,
            "non_rep_net",
            _this.formatVars["colorNonRepDn"],
            _this.formatVars["colorNonRepUp"],
            "fillColorSelNR",
            i,
          );
          fillColors(
            d,
            "non_commercial_net",
            _this.formatVars["colorNonComDn"],
            _this.formatVars["colorNonComUp"],
            "fillColorSelNC",
            i,
          );
          fillColors(
            d,
            "open_interest",
            _this.formatVars["colorOpIntDn"],
            _this.formatVars["colorOpIntUp"],
            "fillColorSelOI",
            i,
          );
        }
      });
    },
    single(fieldName) {
      this.fieldUp = fieldName;
    },
    createCharts() {
      if (this.allData.historical.length === 0) return;
      this.createUpperChart();
      this.createMiddleChart();
      this.createLowerChart();
    },
    createUpperChart() {
      const lastDateData = this.allData.historical.at(-1).date;
      const dayOfMonth = lastDateData.getDate();
      const currentDate = new Date();

      const differenceInMilliseconds = currentDate - lastDateData;
      const millisecondsInDay = 24 * 60 * 60 * 1000;
      const daysSinceLastDate = Math.floor(
        differenceInMilliseconds / millisecondsInDay,
      );
      if (daysSinceLastDate > 7) {
        lastDateData.setDate(dayOfMonth);
        this.additionalDates = this.processData.createNWeeks(lastDateData, 8);
      }
      // === Fixing interval
      if (this.pickedDateInterval !== "-1") {
        this.selectedWeeks = lengthByDate(
          this.pickedDateInterval,
          this.allData.historical.map((d) => d.date),
        );
        let xMin = this.allData.historical[
          this.allData.historical.length - this.selectedWeeks
        ].date;
        let xMax = this.additionalDates[this.additionalDates.length - 1].date;
        let data = this.allData.historical.map((d) => d);
        this.allData.historicalSliced = data.filter(function(d) {
          return inRange(d.date, xMin, xMax);
        });
      }

      // === set SVG canvas
      this.D3ChartCOT.setSVG({
        top: { perc: 0.5, px: 5 },
        right: { perc: 0.5, px: 60 },
        bottom: { perc: 0.5, px: 25 },
        left: { perc: 0.025, px: 12 },
        colorTheme: this.colorTheme,
        logo: this.formatVars["logo"],
      });

      // ==== zoom setup
      this.D3ChartCOT.enableXZoom("chartBodyCOT");

      // === minMax
      let minMaxYAxis;
      minMaxYAxis = this.getMinMaxYAxis();
      minMaxYAxis = [minMaxYAxis[0], minMaxYAxis[1]];
      // === set axis
      this.D3ChartCOT.setAxisDateLin({
        xRange: this.allData.historical
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        minMaxYAxis: minMaxYAxis,
        yAxisLeft: false,
        zeroLineField: "zeroLineCOT",
      });

      this.svgNode = this.D3ChartCOT.svg; // TO DELETE
      this.chartBodyCOT = this.D3ChartCOT.svgAux; // TO DELETE

      // initial transform - zoom
      if (this.pickedDateInterval !== "-1") {
        let addLen = this.additionalDates.length;
        let k = this.allData.historical.length / (this.selectedWeeks + addLen);
        let ty =
          ((this.selectedWeeks + addLen) / this.allData.historical.length - 1) *
          this.svgNode.height;
        let tx =
          ((this.selectedWeeks + addLen) / this.allData.historical.length - 1) *
          this.svgNode.width;
        this.transform = zoomIdentity.scale(k).translate(tx, ty);
        this.xt = this.transform.rescaleX(this.svgNode.x);
        this.bandWidth =
          this.svgNode.x(this.allData.historical[1].date) -
          this.svgNode.x(this.allData.historical[0].date);
        this.candleWidth = this.bandWidth * this.barWidth + 1;
      }
      // === main - line
      this.D3ChartCOT.addLines({
        type: "linesArea",
        data: this.allData.historicalSliced,
        areaColor: this.formatVars["colorLineArea"](this.colorTheme),
        xIsDate: true,
        fieldArea: "areaClose",
        upperLineInfo: {
          color: this.formatVars["colorLine"](this.colorTheme),
          width: 5,
          isDashed: false,
          upperName: "close",
          field: "close",
        },
        lowerLineInfo: {
          color: "rgba(0,0,0,0)",
          width: 0.5,
          isDashed: false,
          lowerName: "zero",
          field: "lowerLineCOT",
        },
      });

      // === highlight - line
      this.D3ChartCOT.addLines({
        type: "line",
        data: this.allData.historicalSliced,
        color: this.formatVars["colorHighlight"](this.colorTheme),
        lineWidth: 1,
        fieldMame: "pHighlight",
        xIsDate: true,
        fieldLine: "highlightLine",
      });

      // Hovers
      // lines
      this.D3ChartCOT.addHovers({
        colorTheme: this.colorTheme,
        hLine: true,
        vLine: true,
      });
      // dots
      this.D3ChartCOT.addDotHovers({
        type: "dot",
        strokeColor: colorDarkExpo(this.colorTheme),
        circleSize: 3,
        strokeWidth: 1,
      });
      // tooltips
      let valueLast = this.allData.historical.at(-1).close;
      this.D3ChartCOT.createToolTipsHover(["y", "x", "last-y"], {
        currencyFormat: this.currencyFormat,
        valueLast: valueLast,
        colorTheme: this.colorTheme,
      });
    },
    createMiddleChart() {
      // === set SVG canvas
      this.D3ChartNET.setSVG({
        top: { perc: 0.5, px: 5 },
        right: { perc: 0.5, px: 60 },
        bottom: { perc: 0.5, px: 25 },
        left: { perc: 0.025, px: 12 },
      });

      // ==== zoom setup
      this.D3ChartNET.enableXZoom("chartBodyNet");

      // === Min Max setup
      let minMaxYAxis = this.getMinMaxNet(this.allData.historicalSliced);

      // === set axis
      this.D3ChartNET.setAxisDateLin({
        xRange: this.allData.historical
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        minMaxYAxis: minMaxYAxis,
        yAxisLeft: false,
        zeroLineField: "zeroLineNet",
      });

      // === Adding Bars

      const addNetBar = (
        className,
        filterData,
        fillColor,
        fieldColor,
        toZero,
      ) =>
        this.D3ChartNET.addBars({
          type: "bar",
          hover: {
            strokeColor: textactive(this.colorTheme),
            strokeWidth: 2,
          },
          data: this.allData.historicalSliced,
          customName: className,
          yField: filterData,
          fieldColor: fieldColor,
          fieldBackground: fillColor,
          candleWidth: this.candleWidth,
          toZero: toZero,
        });

      this.svgNodeNet = this.D3ChartNET.svg; // TO DELETE
      this.chartBodyNet = this.D3ChartNET.svgAux; // TO DELETE

      if (this.userSelections["showComm"]) {
        addNetBar(
          "CHistogram",
          "commercial_net",
          "fillColorSel",
          "colorSel",
          true,
        );
        this.D3ChartNET.createBarZoom({
          fillColor: "fillColorSel",
          yField: "commercial_net",
          customName: "CHistogram",
          toZero: true,
        });
      }
      if (this.userSelections["showNonComm"]) {
        addNetBar(
          "NCHistogram",
          "non_commercial_net",
          "fillColorSelNC",
          "colorSel",
          true,
        );
        addNetBar(
          "cotHighlight",
          "cotHighlight",
          "colorSel",
          "cotHighlightColor",
          false,
        );
        this.D3ChartNET.createBarZoom({
          fillColor: "fillColorSelNC",
          yField: "non_commercial_net",
          customName: "NCHistogram",
          toZero: true,
        });
        this.D3ChartNET.createBarZoom({
          fillColor: "colorSel",
          yField: "cotHighlight",
          customName: "cotHighlight",
          strokeColor: "cotHighlightColor",
          toZero: false,
        });
      }
      if (this.userSelections["showNonRep"]) {
        addNetBar(
          "NRHistogram",
          "non_rep_net",
          "fillColorSelNR",
          "colorSel",
          true,
        );
        this.D3ChartNET.createBarZoom({
          fillColor: "fillColorSelNR",
          yField: "non_rep_net",
          customName: "NRHistogram",
          toZero: true,
        });
      }

      // Hovers
      this.D3ChartNET.addHovers({
        colorTheme: this.colorTheme,
        hLine: true,
        vLine: true,
      });

      let valueLast = this.allData.historical.at(-1).non_commercial_net;
      this.D3ChartNET.createToolTipsHover(["y", "x", "last-y"], {
        currencyFormat: this.currencyFormat,
        valueLast: valueLast,
        colorTheme: this.colorTheme,
      });
    },
    createLowerChart() {
      // === set SVG canvas
      this.D3ChartOI.setSVG({
        top: { perc: 0.5, px: 5 },
        right: { perc: 0.5, px: 60 },
        bottom: { perc: 0.5, px: 25 },
        left: { perc: 0.025, px: 12 },
      });

      // ==== zoom setup
      this.D3ChartOI.enableXZoom("chartBodyOI");

      // === min/max
      let minMaxYAxis = this.getMinMaxOI(this.allData.historicalSliced);

      // === set axis
      this.D3ChartOI.setAxisDateLin({
        xRange: this.allData.historical
          .map((d) => d.date)
          .concat(this.additionalDates.map((d) => d.date)),
        minMaxYAxis: minMaxYAxis,
        yAxisLeft: false,
        zeroLineField: "zeroLineOI",
      });

      // === Bars
      this.D3ChartOI.addBars({
        type: "bar",
        hover: {
          strokeColor: textactive(this.colorTheme),
          strokeWidth: 2,
        },
        data: this.allData.historicalSliced,
        customName: "OIHist",
        yField: "open_interest",
        fieldColor: "colorSel",
        fieldBackground: "fillColorSelOI",
        candleWidth: this.candleWidth,
      });

      // Hovers
      this.D3ChartOI.addHovers({
        colorTheme: this.colorTheme,
        hLine: true,
        vLine: true,
      });
      this.D3ChartOI.createBarZoom({
        fillColor: "fillColorSelOI",
        yField: "open_interest",
        toZero: true,
      });
      const valueLast = this.allData.historical.at(-1).open_interest;
      this.D3ChartOI.createToolTipsHover(["y", "x", "last-y"], {
        currencyFormat: this.currencyFormat,
        valueLast: valueLast,
        colorTheme: this.colorTheme,
      });

      this.svgNodeOI = this.D3ChartOI.svg; // TO DELETE
      this.chartBodyOI = this.D3ChartOI.svgAux; // TO DELETE
      this.createHereditaryHovers();
    },
    createHoverFX() {
      if (this.allData.historical.length === 0) {
        return;
      }
      if (this.svgNode.height === 0 || this.svgNode.width === 0) {
        return;
      }
      NetHover(this, this.barWidth, this.D3ChartNET);
      D3HoverZoom({
        _this: this,
        D3Chart: this.D3ChartOI,
        data: this.allData.historical,
        auxName: "OI",
        hoverParents: ["COT", "Net"],
        methodMinMax: "getMinMaxOI",
        barWidth: this.barWidth,
        dataSliced: "historicalSliced",
      });
      CommitmentTradersHover(this, this.D3ChartCOT);
    },
    createHereditaryHovers() {
      // Hereditary to Open Interest
      const hereditaryHovers = [];
      const hereditaryHoversCOT = [];
      this.D3ChartCOT.hoverElements.forEach((d) => {
        if (d instanceof LineHover && d.type === "v") {
          hereditaryHovers.push(d);
        }
      });
      this.D3ChartNET.hoverElements.forEach((d) => {
        if (d instanceof LineHover && d.type === "v") {
          hereditaryHovers.push(d);
          hereditaryHoversCOT.push(d);
        }
      });
      this.D3ChartCOT.hoverElementDots.forEach((d) => {
        if (d instanceof DotHover) {
          hereditaryHovers.push(d);
        }
      });

      this.D3ChartOI.addHereditadryHovers({
        hereditaryInstances: hereditaryHovers,
      });
      this.D3ChartCOT.addHereditadryHovers({
        hereditaryInstances: hereditaryHoversCOT,
      });
    },
    getMinMaxYAxis() {
      let minMaxYAxis = [0, 1];
      let minMaxYAxis2 = [0, 1];
      minMaxYAxis = this.processData.minMax(
        this.allData.historicalSliced,
        "close",
        "close",
      );

      minMaxYAxis = additionalYSpace(minMaxYAxis, 0.1);
      minMaxYAxis2 = additionalYSpace(minMaxYAxis2, 0.1);
      return [minMaxYAxis[0], minMaxYAxis[1], minMaxYAxis2[0], minMaxYAxis2[1]];
    },
    getMinMaxNet(data) {
      let extYAxis = [+Infinity, -Infinity];
      if (this.userSelections["showComm"]) {
        extYAxis = this.processData.minMax(
          data,
          "commercial_net",
          "commercial_net",
          extYAxis,
          true,
        );
      }
      if (this.userSelections["showNonComm"]) {
        extYAxis = this.processData.minMax(
          data,
          "non_commercial_net",
          "non_commercial_net",
          extYAxis,
          true,
        );
      }
      if (this.userSelections["showNonRep"]) {
        extYAxis = this.processData.minMax(
          data,
          "non_rep_net",
          "non_rep_net",
          extYAxis,
          true,
        );
      }
      return additionalYSpace(extYAxis, 0.15);
    },
    getMinMaxOI(data) {
      let minMaxYAxis = this.processData.minMax(
        data,
        "open_interest",
        "open_interest",
        [Infinity, -Infinity],
        true,
      );
      return additionalYSpace(minMaxYAxis, 0.15, "top");
    },
    getComparisonData() {
      this.allData.histAsset = [];
      this.showLoading = true;
      this.showLoadingDataPrep = true;
      if (this.selectedAssetType === 0) {
        // 0: CURRENCY
        this.currencyNumber = this.currencySpecs[
          this.selectedAsset0
        ].pk_i_idcurrency;
        this.comparedAsset = this.currencySpecs[
          this.selectedAsset0
        ].currency_name;
        this.comparedAsset =
          this.comparedAsset.slice(0, 3) + "/" + this.comparedAsset.slice(3, 6);
        this.comparedAssetLong = this.comparedAsset;
      } else if (this.selectedAssetType === 1) {
        // 1: COMMODITY
        this.comparedAsset = this.commoditySpecs[
          this.selectedAsset1
        ].fk_idproduct.toUpperCase();
        this.comparedAssetLong =
          this.comparedAsset +
          " CONTRACT # " +
          this.commoditySpecsFiltered[this.selectedAsset1].selected_contract +
          " (" +
          (this.commoditySpecs[this.selectedAsset1].is_cents
            ? "USc"
            : this.commoditySpecs[this.selectedAsset1].fk_idcurrency) +
          "/" +
          this.commoditySpecs[this.selectedAsset1].fk_idunit +
          ")";
        this.commodityNumber = this.commoditySpecs[
          this.selectedAsset1
        ].pk_idcommodity;
        this.commodityContract = this.commoditySpecs[
          this.selectedAsset1
        ].selected_contract;
      } else if (this.selectedAssetType === 2) {
        // 2: INDEX
        this.comparedAsset = this.indexSpecsLocal[
          this.selectedAsset2
        ].short_name.toUpperCase();
        this.comparedAssetLong = this.indexSpecsLocal[
          this.selectedAsset2
        ].long_name.toUpperCase();
      }
      this.getAllData();
    },
    onSelectedAssetType() {
      if (this.pickedDateInterval === "-1") this.pickedDateInterval = "5Y";
      this.getAllData();
    },
    onUserAssetSelection() {
      this.pickedDateInterval = "5Y";
      this.getComparisonData();
    },
    // ===== Changing time intervals  =====
    onChangeInterval(item) {
      this.showLoadingDataPrep = true;
      this.pickedDateInterval = item;
      this.sliceMethod();
      this.showLoadingDataPrep = false;
      this.deleteCharts();
      this.createCharts();
      this.createHoverFX();
    },
    intervalTable(net) {
      const priceNetInterval = (interval) =>
        this.allData.historical[this.allData.historical.length - interval][
          net["k"]
        ];
      return {
        ...net,
        ...(net["Today"] = priceNetInterval(1)),
        ...(net["1W"] = priceNetInterval(2)),
        ...(net["4W"] = priceNetInterval(5)),
      };
    },
    createTableFormat() {
      let _this = this;
      Object.assign(this.formatVars, {
        tableFormat: [
          {
            back: _this.formatVars["colorNonComBack"](this.colorTheme),
            bdr: _this.formatVars["colorNonComUp"](this.colorTheme),
            dn: _this.formatVars["colorNonComDn"](this.colorTheme),
            doFormat: false,
            elementName: "barNCHistogram",
            k: "non_commercial_net",
            label: "Non Commercial",
            showFieldName: "showNonComm",
            Today: "",
            "1W": "",
            "4W": "",
          },
          {
            back: _this.formatVars["colorComBack"](this.colorTheme),
            bdr: _this.formatVars["colorComUp"](this.colorTheme),
            dn: _this.formatVars["colorComDn"](this.colorTheme),
            doFormat: true,
            elementName: "barCHistogram",
            k: "commercial_net",
            label: "Commercial",
            showFieldName: "showComm",
          },
          {
            back: _this.formatVars["colorNonRepBack"](this.colorTheme),
            bdr: _this.formatVars["colorNonRepUp"](this.colorTheme),
            dn: _this.formatVars["colorNonRepDn"](this.colorTheme),
            doFormat: true,
            elementName: "barNRHistogram",
            k: "non_rep_net",
            label: "Non Reportable",
            showFieldName: "showNonRep",
          },
        ],
      });
      // this.formatVars["tableFormat"].forEach(net => this.intervalTable(net));
    },
    callWidth() {
      if (this.allData.historical.length > 0) {
        this.deleteCharts();
        this.createCharts();
        this.createHoverFX();
      }
    },
    getAllData() {
      this.deleteCharts();
      Object.assign(this.allData, { historical: [] });
      Object.assign(this.allData, { historicalSliced: [] });
      Object.assign(this.allData, { keys: [] });
      Object.assign(this.allData, { minMaxYAxis: [] });
      getCommitmentTraders(this);
    },
  },
};
</script>

<style scoped>
.COT-table-container {
  margin-left: 0.4rem !important;
}
.container-legends-COT {
  position: absolute;
  left: 15px;
  top: 5px;
}
.container-chart-COT {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
@media (max-width: 1250px) {
  .COT-table-container {
    max-width: 560px;
    overflow: auto;
    overflow-y: hidden;
    justify-content: flex-start;
  }
  .COT-table-container::-webkit-scrollbar:horizontal {
    height: 3px !important;
  }
}
/* @media (min-width: 1440px) {
  .container-legends-COT {
    top: 2%;
  }
  .container-legends {
    top: 90px;
  }
} */
</style>
